import { render, staticRenderFns } from "./TeamMemberCardMobile.vue?vue&type=template&id=2ef5703c&scoped=true&"
import script from "./TeamMemberCardMobile.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TeamMemberCardMobile.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TeamMemberCardMobile.vue?vue&type=style&index=0&id=2ef5703c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5703c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef5703c')) {
      api.createRecord('2ef5703c', component.options)
    } else {
      api.reload('2ef5703c', component.options)
    }
    module.hot.accept("./TeamMemberCardMobile.vue?vue&type=template&id=2ef5703c&scoped=true&", function () {
      api.rerender('2ef5703c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/about-us/index/components/MainContent/components/TeamMemberCardMobile.vue"
export default component.exports